/**
 * 将银行卡号格式化为4位加空格形式的字符串
 * @param value 银行卡号
 * @example $bankcard(6228480402637874213) => '6228 4804 0263 7874 213'
 */
export default function (value: string = ''): string{
	return String(value).replace(/(\d{4})(?=\d)/g, '$1' + ' ');
}
